import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class BillReceivableService {
	private URL = environment.api + "api/erp/billrec";
	constructor(
		private http: HttpClient
	) { }

	getOptions() {
		return this.http.get(this.URL + "/options");
	}

	getBills(idClient) {
		return this.http.get(this.URL + "/bills/60/" + idClient);
	}

	setAdvance(request) {
		return this.http.post(this.URL + "/payment", request);
	}

	getBillsIn(idClient) {
		return this.http.get(this.URL + "/billsIn/" + idClient);
	}

	createCreditNote(request){
		return this.http.post(this.URL + "/creditnote", request);
	}

	getNcreQuantity(documentId: number) {
		return this.http.get(this.URL + "/quantity-ncre/" + documentId);
	}

	getNcreHistory(startDate: string, endDate:string) {
		return this.http.get(this.URL + "/ncre-history/"+startDate + '/' + endDate);
	}

}